import React, { useContext } from 'react';

import { DataContext } from '../../../stores/covering-table-store';
import { Table } from '@devexpress/dx-react-grid-bootstrap4';

import { DeepCopy } from '../shared/TableEventHelpers';
import OnHoverTooltip from '../shared/OnHoverTooltip';
import ClickableTableCell from '../shared/ClickableTableCell';

import { useTranslation } from 'react-i18next';
import { employeeStatusOptions, translateOptionValue } from '../../exl/shared/translations';

const topIndexLimit = 13;

const TableCell = ({ row, column, ...restProps }) => {
    const {
        store: { coverings, expandedRowIDs },
        dispatch,
    } = useContext(DataContext);
    const columnName = column.name;

    let weekNumber = parseInt(columnName);

    const { t } = useTranslation(['shared']);

    if (columnName === 'empName') {
        const Remarks = () => {
            if (!Array.isArray(row.remarks) || !row.remarks.length) {
                return null;
            } else {
                var remarks = row.remarks.map((r, i) => r.dsc).join('\n');
                var idRem = 'remark-label-' + row.empName;
                return (
                    <OnHoverTooltip
                        labelClassNames='remark-info-button d-flex m-auto'
                        dataFor={idRem}
                        tooltipType='light'
                        tooltipPlace='top'
                        tooltipEffect='solid'>
                        <span
                            onClick={() => handleToggleRowDetail(coverings, row['empID'], expandedRowIDs, dispatch)}
                            className='info-tooltips oi oi-info c-steelblue text-center h-100 w-100'
                        />
                        <span className='text-pre-wrap'>{remarks}</span>
                    </OnHoverTooltip>
                );
            }
        };

        return (
            <ClickableTableCell href={`/employee/${row.empID}/info`} showText={row[columnName]}>
                <Remarks />
            </ClickableTableCell>
        );
    } else if (columnName === 'status') {
        const status = t(translateOptionValue(row[columnName], employeeStatusOptions));
        return (
            <Table.Cell {...restProps}>
                    <div className='d-flex align-items-center h-100'>{status}</div>
            </Table.Cell>
        )
    }
    else if (columnName === 'bossName' && !!row.bossID && !!row[columnName]) {
        return <ClickableTableCell href={`/employee/${row.bossID}/info`} showText={row[columnName]} />;
    } else if (columnName === 'office' && !!row.offID && !!row[columnName]) {
        return <ClickableTableCell href={`/office/${row.offID}`} showText={row[columnName]} />;
    } else if (columnName === 'empSkill') {
        var tmpSk = '';
        var check = false;
        if (row.empSkill != null) {
            if (row.empSkill.length > topIndexLimit) {
                tmpSk = row.empSkill.slice(0, topIndexLimit) + '...';
                check = true;
            } else {
                tmpSk = row.empSkill;
            }

            var idSk = 'skill-label-' + row.empName;

            const Comp = () => {
                if (check) {
                    return (
                        <>
                            {tmpSk}
                            <OnHoverTooltip
                                labelClassNames='no-bottom-margin'
                                dataFor={idSk}
                                tooltipType='light'
                                tooltipPlace='top'
                                tooltipEffect='solid'>
                                <span>
                                    <span className='info-tooltips oi oi-info c-steelblue d-flex my-auto w-100 h-100' />
                                </span>
                                <span>{row.empSkill}</span>
                            </OnHoverTooltip>
                        </>
                    );
                } else {
                    return tmpSk;
                }
            };

            return (
                <Table.Cell>
                    <div className='d-flex align-items-center h-100'>
                        <Comp />
                    </div>
                </Table.Cell>
            );
        }

        return <Table.Cell {...restProps} />;
    } else if (!isNaN(weekNumber)) {
        let currentAssignment = null;
        let sumAssignments = row['renderSumAssignments'];
        sumAssignments.map((element) => {
            if (columnName === element['begWek']) {
                currentAssignment = element;
            }
            return null;
        });

        if (currentAssignment !== null) {
            let showVal = currentAssignment['dsc'] ? currentAssignment['dsc'] : currentAssignment['bltName'];
            if (showVal === 'Uppdrag') {
                showVal = '';
            }
            let toolTipVal = '';
            let idWeek = 'week-label-' + row.empName + '-' + columnName;

            let classnames = ' no-selectable-week border-radius-week-cells c-white-smoke with-border';

            if (currentAssignment.bltID === 'BO') {
                toolTipVal = 'Ska Börja';
                classnames += ' c-white week-gray';
            } else if (currentAssignment.bltID === 'SL') {
                toolTipVal = 'Har Slutat';
                classnames += ' c-white week-gray';
            } else {
                let currentPct = currentAssignment['pct'];
                if (currentAssignment['bltID'] === 'SM' || currentAssignment['bltID'] === 'FL' || currentAssignment['bltID'] === 'TL') {
                    classnames += ' week-black';
                    toolTipVal = currentAssignment['bltName'];
                } else if (currentPct <= 100 && currentPct > 75) {
                    classnames += ' week-green';
                    toolTipVal = currentPct + ' %';
                } else if (currentPct <= 75 && currentPct > 50) {
                    classnames += ' week-beige';
                    toolTipVal = currentPct + ' %';
                } else if (currentPct <= 50 && currentPct > 25) {
                    classnames += ' week-orange';
                    toolTipVal = currentPct + ' %';
                } else if (currentPct <= 25 && currentPct > 0) {
                    classnames += ' week-dark-orange';
                    toolTipVal = currentPct + ' %';
                } else if (currentPct === 0) {
                    classnames += ' week-red';
                    showVal = '';
                    toolTipVal = '0 %';
                } else {
                    classnames += ' week-red';
                    showVal = <div className='oi oi-warning m-auto' />;
                    toolTipVal = currentPct + ' %';
                }
            }

            return (
                <Table.Cell
                    className={classnames}
                    {...restProps}
                    colSpan={currentAssignment.colSpan}
                    rowSpan={currentAssignment.rowSpan}
                    onClick={() => handleToggleRowDetail(coverings, row['empID'], expandedRowIDs, dispatch)}>
                    <div className='d-flex align-items-center border-radius-week-cells height-50px w-100'>
                        <OnHoverTooltip
                            labelClassNames='padding-left-10px border-radius-week-cells no-bottom-margin vertical-center-week-cells w-100 h-100'
                            dataFor={idWeek}
                            tooltipType='light'
                            tooltipPlace='top'>
                            <span>{showVal}</span>
                            <span>{toolTipVal}</span>
                        </OnHoverTooltip>
                    </div>
                </Table.Cell>
            );
        }

        return null;
    }

    return (
        <Table.Cell {...restProps}>
            <div className='d-flex align-items-center h-100'>{row[columnName]}</div>
        </Table.Cell>
    );
};

export default TableCell;

const handleToggleRowDetail = (coverings, empID, expandedRowIDs, dispatch) => {
    let newExpandedRowIDs = DeepCopy(expandedRowIDs);
    let clickedIndex = coverings.findIndex((element) => element.empID === empID);

    let isInExpandedRows = newExpandedRowIDs.indexOf(clickedIndex);
    if (isInExpandedRows !== -1) {
        newExpandedRowIDs.splice(isInExpandedRows, 1);
        dispatch({ type: 'UPDATE_ROW_DETAILS', payload: newExpandedRowIDs });
    } else {
        newExpandedRowIDs.push(clickedIndex);
        dispatch({ type: 'UPDATE_ROW_DETAILS', payload: newExpandedRowIDs });
    }
};
